import styled from 'styled-components'

import * as breakpoint from '../../constants/breakpoints'
import * as colors from '../../constants/colors'
import * as glyphs from '../../icons/glyphs'
import * as copy from '../../styles/copy'
import * as heading from '../../styles/heading'

import { ToggleButton } from '../toggle'
import {
  MembershipCardContent,
  MembershipCardImage,
  MembershipCardSubsRemaining,
  MembershipCardWrapper,
} from './membership'

export const MembershipOrderItemWrapper = styled(MembershipCardWrapper)`
  max-width: 288px;
  gap: 0;
  margin-inline: auto;

  @media screen and ${breakpoint.TABLET} {
    max-width: 100%;
  }
`

export const MembershipOrderItemImage = styled(MembershipCardImage)`
  height: 48px;
  width: 90px;
`

export const MembershipOrderItemContent = styled(MembershipCardContent)`
  gap: 16px;
`

export const MembershipOrderItemHeader = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 8px;

  @media screen and ${breakpoint.TABLET} {
    margin-bottom: 0;
  }
`

export const MembershipOrderItemTitle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: fit-content;

  ${heading.XXXS} {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 150px;
  }

  @media screen and ${breakpoint.TABLET} {
    margin-right: 8px;

    ${heading.XXXS} {
      max-width: 260px;
    }
  }
`

export const MembershipOrderItemMain = styled.div`
  display: grid;
  gap: 16px;
  align-items: center;

  @media screen and ${breakpoint.TABLET} {
    grid-template-columns: auto auto 1fr;
    row-gap: 0;
    max-width: 100%;
    min-height: 48px;
  }
`

export const MembershipOrderItemExpand = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ isOpen }) => (isOpen ? '16px' : '0')};
  transition: gap 0.15s ease-in-out;

  & > * {
    max-height: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    overflow: hidden;
    transition: max-height 0.15s ease-in-out;
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    transition: visibility 0.15s ease-in-out;
  }

  @media screen and ${breakpoint.TABLET} {
    display: grid;
    grid-template-columns: 90px auto auto;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    padding-top: ${({ isOpen }) => (isOpen ? '16px' : '0')};
    transition:
      padding-top 0.125s ease-in-out,
      grid-template-rows 0.15s ease-in-out;
  }
`

export const MembershipOrderItemToggle = styled(ToggleButton)<{ isToggled: boolean; isSubscriber?: boolean }>`
  color: ${colors.PRIMARY_GREY_900};
  justify-self: center;
  margin-top: ${({ isSubscriber }) => (isSubscriber ? '-32px' : '0')};
  margin-bottom: ${({ isSubscriber }) => (isSubscriber ? '-10px' : '0')};
  white-space: nowrap;

  @media screen and ${breakpoint.TABLET} {
    justify-self: flex-end;
    margin-block: 0;
  }

  ${glyphs.stroke.CaretDown} {
    color: ${colors.PRIMARY_SAND_500};
  }
`

export const MembershipOrderItemSubsRemaining = styled(MembershipCardSubsRemaining)`
  justify-content: flex-end;
  margin-right: 8px;
  margin-bottom: 8px;
`

export const TaxDeduction = styled(copy.S)`
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: 8px;
  color: ${colors.PRIMARY_SAND_500};
`
